// src/pages/FleetDetail.js — görselsiz, sade sürüm
import React, { useEffect, useState } from "react";
import { parseLocation } from "../router";
import FLEET from "../data/fleet.json";
import { MetaIcon } from "../components/ServiceIcon";

export default function FleetDetail() {
  const [item, setItem] = useState(null);

  useEffect(() => {
    const { params } = parseLocation();
    const found = FLEET.find((f) => f.id === params.id);
    setItem(found || null);
  }, []);

  if (!item) {
    return (
      <section className="section">
        <div className="container">
          <div className="notfound-card">
            <h2>🚧 Araç Bulunamadı</h2>
            <p>Belirttiğiniz araç kaydı bulunamadı veya kaldırılmış olabilir.</p>
            <div className="notfound-actions">
              <a href="/fleet" className="btn ghost">Araç Parkuruna Dön</a>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="section">
      <div className="container">
        <header className="section-head">
          <h1 className="page-title">{item.name}</h1>
          <p className="page-subtitle">
            {item.model} • {item.year} • {item.tonnage || "Tonaj bilgisi yok"}
          </p>
        </header>

        <div className="fleet-detail-info">
          <div className="fleet-meta-grid">
            <div className="fleet-meta-item">
              <MetaIcon type="truck" /> <strong>Model:</strong> {item.model}
            </div>
            <div className="fleet-meta-item">
              <MetaIcon type="year" /> <strong>Yıl:</strong> {item.year}
            </div>
            <div className="fleet-meta-item">
              <MetaIcon type="leaf" /> <strong>Tonaj:</strong> {item.tonnage || "—"}
            </div>
            
          </div>

          <div className="fleet-features-block">
            <h3>Öne Çıkan Özellikler</h3>
            <ul className="fleet-features-list">
              {(item.features || []).map((f, i) => (
                <li key={i}>{f}</li>
              ))}
            </ul>
          </div>

          <div className="fleet-actions-block">
            <a href="/fleet" className="btn ghost">← Tüm Araçlar</a>
          </div>
        </div>
      </div>
    </section>
  );
}